

export default [{
    path: '',
    component: resolve => require(['@/views/home'], resolve),
    name: 'Home',
    keepAlive: true,
    meta: {
      nav: '首页'
    }
  },
  {
    path: 'searchResult',
    component: resolve => require(['@/views/home/searchResult'], resolve),
    name: 'searchResult',
    meta: {
      nav: '搜索结果页'
    }
  },
  {
    path: 'home',
    component: resolve => require(['@/views/home'], resolve),
    name: 'Home',
    keepAlive: true,
    meta: {
      nav: '首页'
    }
  },
 

]



// WEBPACK FOOTER //
// ./src/router/home.js